import { action, observable } from 'mobx';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';
import { AdminGlobalPreferenceController } from 'cd-eft/services/eftPrjAdminApi';

interface IadminGlobalPrefData{
  stateGlobal: number | undefined;
  stateName: number | undefined;
  projectType: number | undefined;
  designElementType: number | undefined;
  prefTypeKey: number | undefined;
}

enum stateGlobal{
 Global = 0,
 User = 1,
 State = 2 
}
enum stateName{
 All = 2,
}
enum projectType{
 Design = 5,
 AnalysisHydro = 1,
 AnalysisWSC = 2,
 AnalysisFormula = 3
}
enum designElementType{
 GrassedWaterway = 7,
 LinedWaterway = 19,
 Terrace = 8,
 Pit = 9,
 Pad = 10
}

export class AdminGlobalPreferencesVM {
mode: 'design' | 'standalone' | 'adminGlobalPreferences' = 'adminGlobalPreferences';

@observable isLoading : boolean = false;
@observable stateGlobalOptions: any = [
  { name: 'Global', value: stateGlobal.Global },
  { name: 'User', value: stateGlobal.User },
  { name: 'State', value: stateGlobal.State },
];
@observable stateNameOptions: any = [
  { name: 'All', value: stateName.All }
];
@observable projectTypeOptions: any = [
  { name: 'Design', value: projectType.Design },
  { name: 'Analysis-Hydro', value: projectType.AnalysisHydro },
  { name: 'Analysis-WSC', value: projectType.AnalysisWSC },
  { name: 'Analysis-Formula', value: projectType.AnalysisFormula },
];
@observable designElementTypeOptions: any = [
  { name: 'Grassed Waterway', value: designElementType.GrassedWaterway },
  { name: 'Lined Waterway', value: designElementType.LinedWaterway },
  { name: 'Terrace', value: designElementType.Terrace },
  { name: 'Pit', value: designElementType.Pit },
  { name: 'Pad', value: designElementType.Pad },
];
// @observable preferenceTypeKeysOptions :any = [{name:'Grassed Waterway Trapezoidal Channel Shape', value: 100},{name:'Grassed Waterway Parabolic Channel Shape', value: 101},{name:'Lined Waterway Trapezoidal Channel Shape', value: 110},{name:'Lined Waterway Parabolic Channel Shape', value: 111}]
@observable preferenceTypeKeysOptionsAPI: any = [];
@observable preferenceJson : any =[];
@observable adminGlobalPrefData: IadminGlobalPrefData = {
  stateGlobal: stateGlobal.Global,
  stateName: stateName.All,
  projectType: projectType.Design,
  designElementType: undefined,
  prefTypeKey: undefined,
};

@observable formValidation = {
  hasError: true,
  stateGlobal: false,
  stateName: false,
  projectType: false,
  designElementType: false,
  prefTypeKey: false,
  formErrors: {
    hasError: '',
    stateGlobal: '',
    stateName: '',
    projectType: '',
    designElementType: '',
    prefTypeKey: '',
  }

}
 @action.bound handleInputChange(event){
  const { name, value } = event.target;

  let val : number | undefined = parseFloat(value);
  if (isNaN(val) || value === '') {
    val = undefined; 
  }

  switch (name) {
    case 'state-global':
      this.adminGlobalPrefData.stateGlobal = val;
      if (value === 0) {
        this.adminGlobalPrefData.stateName = 2;
      }
      if(val === undefined){
        this.preferenceTypeKeysOptionsAPI = [];
        this.designElementTypeOptions = [];
        this.adminGlobalPrefData.prefTypeKey = undefined;
        this.adminGlobalPrefData.designElementType = undefined;
      }
      this.preferenceJson ={};
      break;
    case 'state-name':
      this.adminGlobalPrefData.stateName = val;
      if(val === undefined){
        this.preferenceTypeKeysOptionsAPI = [];
        this.designElementTypeOptions = [];
        this.adminGlobalPrefData.prefTypeKey = undefined;
        this.adminGlobalPrefData.designElementType = undefined;
      }
      this.preferenceJson ={};
      break;
    case 'project-type':
      this.adminGlobalPrefData.projectType = val;
      if(val === undefined){
        this.preferenceTypeKeysOptionsAPI = [];
        this.designElementTypeOptions = [];
        this.adminGlobalPrefData.prefTypeKey = undefined;
        this.adminGlobalPrefData.designElementType = undefined;
      }
      this.preferenceJson ={};
      break;
    case 'design-element-type':
      this.adminGlobalPrefData.designElementType = val;
      if(val === undefined){
        this.preferenceTypeKeysOptionsAPI = [];
        this.adminGlobalPrefData.prefTypeKey = undefined;
      }
      this.preferenceJson ={};
      if(value){  // added manually here because for some reason the error message was triggered for last dropdown
        this.formValidation.designElementType = false;
        this.formValidation.formErrors.designElementType = '';
        this.formValidation.hasError = false;
      }
      break;
    case 'preferences-type-key':
      this.adminGlobalPrefData.prefTypeKey = val;
      this.preferenceJson ={};
      if(value){  // added manually here because for some reason the error message was triggered for last dropdown
        this.formValidation.prefTypeKey = false;
        this.formValidation.formErrors.prefTypeKey = '';
        this.formValidation.hasError = false;
      }
      break;
  }
}

@action.bound async validateInput(name, value) {
  switch (name) {
    case 'state-global':
      if (value === '') {
        this.formValidation.stateGlobal = true;
        this.formValidation.formErrors.stateGlobal = ' ';
        this.formValidation.hasError = true;
        this.designElementTypeOptions =[];
        this.preferenceTypeKeysOptionsAPI = [];
        this.adminGlobalPrefData.designElementType = undefined;
        this.adminGlobalPrefData.prefTypeKey = undefined;
        await MessageCenter.addNotificationFromCode('Common_09', undefined,'State/Global' );
      } else {
        this.formValidation.stateGlobal = false;
        this.formValidation.formErrors.stateGlobal = '';
        this.formValidation.hasError = false;
        this.setDesignElementOptions();
      }
      break;
    case 'state-name':
      if (value === '') {
        this.formValidation.stateName = true;
        this.formValidation.formErrors.stateName = ' ';
        this.formValidation.hasError = true;
        this.designElementTypeOptions =[];
        this.preferenceTypeKeysOptionsAPI = [];
        this.adminGlobalPrefData.designElementType = undefined;
        this.adminGlobalPrefData.prefTypeKey = undefined;
        await MessageCenter.addNotificationFromCode('Common_09', undefined,'State Name' );
      } else {
        this.formValidation.stateName = false;
        this.formValidation.formErrors.stateName = '';
        this.formValidation.hasError = false;
        this.setDesignElementOptions();
      }
      break;
    case 'project-type':
      if (value === '' || Number.isNaN(value) || value === undefined) {
        this.formValidation.projectType = true;
        this.formValidation.formErrors.projectType = ' ';
        this.formValidation.hasError = true;
        this.designElementTypeOptions =[];
        this.preferenceTypeKeysOptionsAPI = [];
        this.adminGlobalPrefData.designElementType = undefined;
        this.adminGlobalPrefData.prefTypeKey = undefined;
        await MessageCenter.addNotificationFromCode('Common_09', undefined,'Project Type' );
      } else {
        this.setDesignElementOptions();
        this.formValidation.projectType = false;
        this.formValidation.formErrors.projectType = '';
        this.formValidation.hasError = false;
      }
      break;
    case 'design-element-type':
      if (value === '' || Number.isNaN(value) || value === undefined) {
        this.formValidation.designElementType = true;
        this.formValidation.formErrors.designElementType = ' ';
        this.formValidation.hasError = true;
        this.preferenceTypeKeysOptionsAPI = [];
        this.adminGlobalPrefData.prefTypeKey = undefined;
        await MessageCenter.addNotificationFromCode('Common_09', undefined,'Design Element Type' );
      } else {
        await this.getPreferencesTypeKeyData();
        this.formValidation.designElementType = false;
        this.formValidation.formErrors.designElementType = '';
        this.formValidation.hasError = false;
      }
      break;
    case 'preferences-type-key':
      if (value === '' || value === undefined || Number.isNaN(value)){
        this.formValidation.prefTypeKey = true;
        this.formValidation.formErrors.prefTypeKey = ' ';
        this.formValidation.hasError = true;
        await MessageCenter.addNotificationFromCode('Common_09', undefined,'Preferences Type Key' );
      } else {
        if(this.adminGlobalPrefData.designElementType === 7){await this.getPreferenceJson()}
        this.formValidation.prefTypeKey = false;
        this.formValidation.formErrors.prefTypeKey = '';
        this.formValidation.hasError = false;
      }
      break;
  }
}

@action.bound setDesignElementOptions() {
  if (
    !this.formValidation.stateGlobal &&
    !this.formValidation.stateName &&
    this.adminGlobalPrefData.projectType === projectType.Design
  ) {
    // Populate Design project options
    this.designElementTypeOptions = [
      { name: 'Grassed Waterway', value: designElementType.GrassedWaterway },
      { name: 'Lined Waterway', value: designElementType.LinedWaterway },
      { name: 'Terrace', value: designElementType.Terrace },
      { name: 'Pit', value: designElementType.Pit },
      { name: 'Pad', value: designElementType.Pad },
    ];
  }
  else {
    // no other project types yet
    this.designElementTypeOptions = [];
    this.preferenceTypeKeysOptionsAPI = [];
    this.adminGlobalPrefData.prefTypeKey = undefined;
    this.adminGlobalPrefData.designElementType = 0;// 0 for now to reset the option to blank
  }
  
}

validatationForAccordions(){
  if(this.adminGlobalPrefData.stateGlobal === stateGlobal.Global && this.adminGlobalPrefData.stateName === stateName.All && this.adminGlobalPrefData.projectType === projectType.Design && this.adminGlobalPrefData.designElementType === designElementType.GrassedWaterway && this.adminGlobalPrefData.prefTypeKey){
    return true
  }
  return false
}

validateRequiredFieldsForPrefTypeKeyData() {
  if (
    this.formValidation.stateGlobal ||
    this.formValidation.stateName ||
    this.formValidation.designElementType ||
    this.formValidation.projectType
  ) {
    return false;
  }
  return true;
}

@action.bound async getPreferencesTypeKeyData() {
  this.isLoading = true;
  const validated = this.validateRequiredFieldsForPrefTypeKeyData();
  MessageCenter.blockCalls(['Common_26']);
  if (validated) {
    try {
      const response = await AdminGlobalPreferenceController.getPreferenceTypeKeyListByScopeAndProjectTypeAndDesignElementTypeUsingGET(
        this.adminGlobalPrefData.stateName as number,
        this.adminGlobalPrefData.projectType as number,
        this.adminGlobalPrefData.designElementType as number
      );
      if (response && response.data && response.data.length) {
        this.preferenceTypeKeysOptionsAPI = [];
        this.preferenceTypeKeysOptionsAPI = response.data.filter(num=> num === '100' || num === '101').map((item) => {
          if (item === '100') {
            return { name: 'Grassed Waterway Trapezoidal Channel Shape', value: item };
          } else if (item === '101') {
            return { name: 'Grassed Waterway Parabolic Channel Shape', value: item };
          }
        });
      } else {
        this.adminGlobalPrefData.prefTypeKey = undefined;
        this.preferenceTypeKeysOptionsAPI = [];
      }
    } catch (error) {
      console.error(error);
    }
  } else {
    this.adminGlobalPrefData.prefTypeKey = undefined;
    this.preferenceTypeKeysOptionsAPI = [];
    MessageCenter.resetMessageCenter();
    MessageCenter.unblockCalls();
    await MessageCenter.addNotificationFromCode('Common_26');
  }
  MessageCenter.unblockCalls();
  this.isLoading = false;
}

@action.bound async getPreferenceJson(){

  this.isLoading = true;
  const validated = this.formValidation.prefTypeKey || this.validateRequiredFieldsForPrefTypeKeyData()
  MessageCenter.blockCalls(['Common_26']);
  if (validated) {
    try {
      const response = await AdminGlobalPreferenceController.getPreferenceJsonByPreferenceScopeAndPreferenceKeyIdUsingGET(this.adminGlobalPrefData.stateName as number,this.adminGlobalPrefData.prefTypeKey as number);
      if (response && response.data) {
        this.preferenceJson = response.data;
      } else {
        this.preferenceJson = {};
      }
    } catch (error) {
      console.error(error);
    }
  } else {
    this.preferenceJson = {}
    MessageCenter.resetMessageCenter();
    MessageCenter.unblockCalls();
    await MessageCenter.addNotificationFromCode('Common_26');
  }
  MessageCenter.unblockCalls();
  this.isLoading = false;
}

@action.bound adminGlobalPreferencesErrorClass(field) {
  const errorMessage = this.formValidation.formErrors[field];
  return errorMessage?.length === 0 ? '' : ' usa-input--error';
}
}
